import * as React from "react";
import { IFormula } from "@graffer-inc/form-schema";
import {
  InvoiceItemSetting,
  MAX_PAYMENT_ITEM_NUM,
} from "@graffer-inc/cloud-gov-core";
import { TextButton } from "@graffer-inc/console-design-kit";
import { useModal } from "../../../../../../utils/custom-hooks";
import { PaymentItemLine } from "./payment-item-line";
import { PaymentSettingEditModal } from "./../edit-modal";
import { ErrorMessage } from "./../../../../../atoms/error-message";

export type PaymentItemTableProps = {
  formulaEditHref: string;
  items: InvoiceItemSetting[];
  formulas: IFormula[];
  onChange: (v: InvoiceItemSetting[] | undefined) => void;
  readonly?: boolean;
};

export const PaymentItemTable: React.FC<PaymentItemTableProps> = ({
  formulaEditHref,
  items,
  formulas,
  onChange,
  readonly,
}) => {
  const editModal = useModal();
  const [editTarget, setEditTarget] = React.useState<{
    index: number;
    item: InvoiceItemSetting;
  }>();
  return (
    <>
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th style={{ minWidth: "80px" }}>費目</th>
            <th>税率</th>
            <th style={{ minWidth: "80px" }}>数式ID</th>
            <th>自動計算数式</th>
            <th aria-label="アクション" />
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <PaymentItemLine
              key={item.formulaId}
              item={item}
              formula={formulas.find((f) => f.id === item.formulaId)}
              onDelete={() => {
                const filtered = items.filter((_, idx) => idx !== index);
                onChange(filtered.length > 0 ? filtered : undefined);
              }}
              onEdit={() => {
                setEditTarget({ index, item });
                editModal.open();
              }}
              readonly={readonly}
            />
          ))}
          {!readonly && (
            <tr className="has-text-left">
              <td colSpan={5}>
                {items.length === 0 && (
                  <ErrorMessage msg="決済設定を追加してください。" />
                )}
                <TextButton
                  text="追加"
                  icon="PlusCircleSolidIcon"
                  disabled={items.length >= MAX_PAYMENT_ITEM_NUM}
                  onClick={editModal.open}
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {editModal.isActive && (
        <PaymentSettingEditModal
          formulaEditHref={formulaEditHref}
          initItem={editTarget?.item}
          formulas={formulas}
          onSave={(item) => {
            if (!editTarget) {
              onChange([...items, item]);
            } else {
              onChange(
                items.map((v, idx) => (idx !== editTarget.index ? v : item)),
              );
            }
            setEditTarget(undefined);
            editModal.close();
          }}
          onClose={() => {
            setEditTarget(undefined);
            editModal.close();
          }}
        />
      )}
    </>
  );
};
